import { useState, useImperativeHandle, forwardRef } from 'react'
import TextField from '../TextField'
import './styles.css'

const ShareEmailModal = forwardRef(({ onSend, onCancel }, ref) => {
  const [email, setEmail] = useState('')

  useImperativeHandle(ref, () => ({
    getEmail: () => email,
    send: () => {
      if (email.trim()) {
        onSend(email)
      }
    }
  }))

  return (
    <div className="share-email-modal">
      <div className="share-email-field">
        <label className="share-email-label">E-mail</label>
        <TextField
          type="email"
          placeholder="Ingrese el correo electrónico"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </div>
    </div>
  )
})

ShareEmailModal.displayName = 'ShareEmailModal'

export default ShareEmailModal
